<template>
    <b-container>
        <b-row class="mb-3">
            <b-col cols="6" lg="3">
                <DateInput v-model="fromDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <DateInput v-model="toDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <b-form-select v-model="interval" :options="intervalOptions"></b-form-select>
            </b-col>
<!--            <b-col cols="6" lg="6">-->
<!--                <b-form-select v-model="filterOption" :options="filterOptions"></b-form-select>-->
<!--            </b-col>-->
            <b-col cols="6" lg="3">
                <b-button-group block class="w-100">
                    <b-button @click="getData">{{$t('admin_report.show_report')}}</b-button>
                    <b-button variant="light" @click="exportData">
                        <font-awesome-icon icon="file-export"></font-awesome-icon>
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <BarChart :chart-data="chartData" height="200px"></BarChart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import {DateTime} from 'luxon'
import BarChart from "./BarChart";
import DateInput from "../DateInput";
import {library} from '@fortawesome/fontawesome-svg-core'
import {faFileExport} from '@fortawesome/free-solid-svg-icons'

library.add(faFileExport);

    export default {
        name: 'AccPaymentReport',
        components: {DateInput, BarChart},
        data() {
            return {
                fromDate: DateTime.local().startOf('year').toISO(),
                toDate: DateTime.local().endOf('year').toISO(),
                interval: 1,
                intervalOptions: [
                    {value: 1, text: this.$t('admin_report.interval_month')},
                    {value: 12, text: this.$t('admin_report.interval_year')},
                ],
                rawData: null,
            }
        },
        computed: {
            chartData() {
                if (!this.rawData) {
                    return {}
                }

                let datasets = [];
                let v = this;
                [
                    // 'octopus_count',
                    // 'octopus_amount',
                    'cyber_source_count',
                    'cyber_source_amount',
                    'union_pay_count',
                    'union_pay_amount',
                    'coupon_count',
                    'coupon_amount',
                ].forEach(function (t) {
                    let color = 'rgba(' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', 0.5)';

                    let data = v.rawData[t].map(function (d) {
                        // return Math.floor(Math.random() * Math.floor(10));
                        return d.value;
                    });

                    datasets.push({
                        backgroundColor: color,
                        label: v.$t('admin_report.' + t),
                        data: data,
                    });
                });

                let labels = this.rawData['octopus_count'].map(function (d) {
                    return d.label;
                });

                return {
                    labels: labels,
                    datasets: datasets,
                }
            },
        },
        mounted() {

        },
        methods: {
            getData() {
                this.$callAPI('hkiarace/admin/report/', {
                    report_type: 'ACC_PAYMENT_REPORT',
                    params: {
                        from: DateTime.fromISO(this.fromDate).toSeconds(),
                        to: DateTime.fromISO(this.toDate).toSeconds(),
                        interval: this.interval,
                    },
                }, function (response) {
                    this.rawData = response.body.datasets;
                })
            },
            exportData() {
                this.$downloadFile('hkiarace/admin/report/export/', {
                        report_type: 'ACC_PAYMENT_REPORT',
                        params: {
                            from: DateTime.fromISO(this.fromDate).toSeconds(),
                            to: DateTime.fromISO(this.toDate).toSeconds(),
                            interval: this.interval,
                        },
                    },
                    'export.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            },
        },
    }
</script>

<style>

</style>
